export interface IBetslipNotification {
    readonly message: string;

    isEqual(otherNotification: IBetslipNotification | null): boolean;
}

export class SimpleBetslipNotification implements IBetslipNotification {
    readonly message: string;

    constructor(message: string) {
        this.message = message;
    }

    isEqual(otherNotification: IBetslipNotification | null): boolean {
        return otherNotification instanceof SimpleBetslipNotification && this.message === otherNotification.message;
    }
}

export class ExtendedBetslipNotification implements IBetslipNotification {
    readonly title: string;
    readonly message: string;

    constructor(title: string, message: string) {
        this.title = title;
        this.message = message;
    }

    isEqual(otherNotification: IBetslipNotification | null): boolean {
        return (
            otherNotification instanceof ExtendedBetslipNotification &&
            this.title === otherNotification.title &&
            this.message === otherNotification.message
        );
    }
}

export class OveraskBetslipNotification implements IBetslipNotification {
    readonly message: string;
    readonly title?: string;

    constructor(message: string, title?: string) {
        this.message = message;
        this.title = title;
    }

    isEqual(otherNotification: IBetslipNotification | null): boolean {
        return otherNotification instanceof OveraskBetslipNotification && this.message === otherNotification.message;
    }
}

export class BetBuilderBetslipNotification extends SimpleBetslipNotification {
    constructor(message: string) {
        super(message);
    }
}
